//export var app = window.app;
export var egw = window.egw;
export var framework = window.framework;
export var app = window.app;
export var egw_getFramework = window.egw_getFramework;
export var jQuery = window.jQuery;